module.exports = __webpack_public_path__ + "static/media/arrow-down-blue.07452ee9.svg";